
import React, { Component } from 'react';
import * as util from './util';

import './file-upload-ng.css';

export class FileUploadNG extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onUpload = this.onUpload.bind(this);

    this.state = {fileName: null,
                  fileInputID: 'fileInput' + Math.floor(Math.random() * 10000000),
                  spanID: 'span' + Math.floor(Math.random() * 10000000),
                  formID: 'form' + Math.floor(Math.random() * 10000000),
                  initial: true
    };
  };

  onClick(event) {
    var hiddenFileInput = document.getElementById(this.state.fileInputID);
    if(!this.state.XHRLoad) {
      hiddenFileInput.click();
    }
  }

  onChange(event) {
    var fileInput =  document.getElementById(this.state.fileInputID);
    var file = fileInput.files[0];
    this.setState( {fileName: file.name,
                    success: false,
                    XHRStart: false,
                    XHRLoad: false,
                    XHRError: null,
                    XHRAbort: null,
                    XHRProgress: null,
                    progress: 0
    });
  }

  onUpload(event) {
    if(this.state.fileName) {
      var headers = util.defaultHeaders();
      var self = this;

      var form = document.getElementById(this.state.formID);
      var xhr = new XMLHttpRequest();
      this.setState({XHRStart: true});
      xhr.addEventListener("load", () => this.setState({XHRLoad: true}));
      xhr.addEventListener("error", () => console.log('Error during file upload.'));
      xhr.addEventListener("abort", () => console.log('File upload aborted.'));
      xhr.upload.addEventListener("progress", (event) => this.setState({ progress: event.loaded / event.total }));
      xhr.open('POST', form.action, true);
      xhr.setRequestHeader("Authorization", headers.get("Authorization"));
      xhr.onload = function(event) {
        if (this.status === 200) {
          if (this.responseText !== null) {
            var json = JSON.parse(this.responseText);
            if(json.uploadSuccess === true) {
              self.props.onFinish(json.uuid, self.props.index, json.fileName);
              alert(json.fileName + ' wurde hochgeladen.');
            } else {
              self.setState ({fileName: null,
                              success: false,
                              XHRStart: false,
                              XHRLoad: false
              });
              alert('Datei konnte nicht hochgeladen werden.');
            }
          }
        }
      };
      xhr.send(new FormData(form));
    } else {
      event.preventDefault();
    }
  }

  uploadStatus() {
    if (this.state.XHRStart) {
      if (this.state.XHRLoad) {
        return <span style={{color: '#1F6A81', display: 'inline-block'}} > ✓ </span>;
      } else {
        return <span className="file-upload-ng-spin" style={{color: 'red', display: 'inline-block'}} > ↑ </span>;
      }
    } else {
      if (this.state.fileName !== null && this.state.fileName !== undefined && this.state.fileName !== '')
      {
        return <div className="button buttonSmall" onClick={this.onUpload}> Hochladen </div>;
      }
    }
    return null;
  }

  render() {
    return (
      <form className="fileUploadNG" id={this.state.formID} action={'/api/upload'} name="form" method='post' onSubmit={this.onUpload}>
        <span id={this.state.spanID}>{this.props.title}</span>
        <br/>
        <input style={{display: 'none'}} type="file" name="file" onChange={this.onChange} id={this.state.fileInputID} />
        <input className="FileUploadInput" type='text' placeholder="(durch Klick auswählen)" onClick={this.onClick} name="submit" value={this.state.fileName} readOnly={true}
               style={{cursor: 'pointer', color: 'black'}}
               title={this.props.title} /> 
        <br />
        <span style={{fontSize: 'small'}}>Ausgewählte Dateien müssen mit dem "Hochladen" Button" bestätigt werden.</span>
        {this.uploadStatus()}
        {this.state.XHRStart && this.state.progress !== 1 && <span> ({Math.floor(100*this.state.progress)}%) </span>}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/file-upload-ng.js